/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import NoteConstants from 'constants/NoteConstants'
import NoteQueries from 'queries/NoteQueries'

const NoteStore = Marty.createStore({
  id: 'NoteStore',

  getInitialState() {
    return {
      notesByEndUserId: {},
      notesByCompanyId: {}
    }
  },

  handlers: {
    fetchNoteListForEndUserIdDone: NoteConstants.NOTE_LIST_FOR_END_USER_FETCH_DONE,
    fetchNoteListForCompanyIdDone: NoteConstants.NOTE_LIST_FOR_COMPANY_FETCH_DONE,
    createNoteForEndUserDone: NoteConstants.NOTE_END_USER_CREATE_DONE,
    createNoteForCompanyDone: NoteConstants.NOTE_COMPANY_CREATE_DONE
  },

  // MESSAGES
  getOrFetchNoteListForEndUserId(endUserId) {
    return this.fetch({
      id: `getOrFetchNoteListForEndUserId${ endUserId }`,
      locally() {
        return this.state.notesByEndUserId[endUserId]
      },
      remotely() {
        return this.app.queries.NoteQueries.fetchNotesForEndUserId(endUserId)
      }
    })
  },

  fetchNoteListForEndUserIdDone(endUserId, notes) {
    const notesByEndUserId = _.cloneDeep(this.state.notesByEndUserId)
    notesByEndUserId[endUserId] = notes
    return this.setState({ notesByEndUserId })
  },

  getOrFetchNoteListForCompanyId(companyId) {
    return this.fetch({
      id: `getOrFetchNoteListForCompanyId${ companyId }`,
      locally() {
        return this.state.notesByCompanyId[companyId]
      },
      remotely() {
        return this.app.queries.NoteQueries.fetchNotesForCompanyId(companyId)
      }
    })
  },

  fetchNoteListForCompanyIdDone(companyId, notes) {
    const notesByCompanyId = _.cloneDeep(this.state.notesByCompanyId)
    notesByCompanyId[companyId] = notes
    return this.setState({ notesByCompanyId })
  },

  createNoteForEndUserDone(endUserId, note) {
    const notesByEndUserId = _.cloneDeep(this.state.notesByEndUserId)
    const notes = _.reject(notesByEndUserId[endUserId], 'id', note.id)
    notes.push(note)
    notesByEndUserId[endUserId] = notes
    return this.setState({ notesByEndUserId })
  },

  createNoteForCompanyDone(companyId, note) {
    const notesByCompanyId = _.cloneDeep(this.state.notesByCompanyId)
    const notes = _.reject(notesByCompanyId[companyId], 'id', note.id)
    notes.push(note)
    notesByCompanyId[companyId] = notes
    return this.setState({ notesByCompanyId })
  }
})

export default NoteStore



// WEBPACK FOOTER //
// ./src/scripts/stores/NoteStore.js